import AuthLayout from '../components/auth/AuthLayout'
import ForgotPasswordForm from '../components/auth/ForgotPasswordForm'
import MetaTags from '../components/common/MetaTags'

export default function ForgotPasswordPage() {
  return (
    <AuthLayout>
      <MetaTags
        title="Reset Password | profile.work"
        description="Reset your profile.work account password."
      />
      <ForgotPasswordForm />
    </AuthLayout>
  )
}
